/** Whether a run exercises the flow for real or as a test. */
export var FlowRunType;
(function (FlowRunType) {
    FlowRunType["Test"] = "test";
    FlowRunType["Production"] = "production";
})(FlowRunType || (FlowRunType = {}));
/**
 * Display order for run types, production first. Declaration order of the enum is not a
 * contract, so anything rendering one element per run type orders by this instead.
 */
export const ORDERED_FLOW_RUN_TYPES = [FlowRunType.Production, FlowRunType.Test];
//# sourceMappingURL=runType.js.map